<script setup lang="ts">
import { URL_IMAGE } from '@/config/constants'
import { languageIdBus } from '@/event/languageIdBus'
import type { Option } from '@/storage/products'
import type { getOptionValueName } from '@/utils/product/getOptionValueName'
import { getOptionValueNameById } from '@/utils/product/getOptionValueNameById'
import ButtonSelectOptionValueHappy from './ButtonSelectOptionValueHappy.vue'

const emit = defineEmits<{
    (
        e: 'selectOption',
        option: {
            name_option: string
            value_option: Option
        }
    ): void
}>()

function handleSelect(option: Option) {
    emit('selectOption', {
        name_option: props.name_option,
        value_option: option
    })
}

const props = defineProps<{
    name_option: string
    options: Option
}>()
</script>

<template>
    <section class="section-option-value-happy">
        <div
            class="div-option-value-happy"
            v-if="props.options"
            v-for="(option_value, index) in props.options.values"
            :key="index"
        >
            <div class="div-option-value-description-happy">
                <div class="div-info-option-value-happy">
                    <img
                        class="img-option-value-happy"
                        :src="`${URL_IMAGE}${option_value.image}`"
                        alt=""
                    />
                    <span> - </span>
                    <p class="text-option-value-happy">
                        {{
                            getOptionValueNameById(
                                option_value.option_value_id,
                                languageIdBus
                            )
                        }}
                    </p>
                </div>
                <ButtonSelectOptionValueHappy />
            </div>
        </div>
    </section>
</template>

<style scoped>
.section-option-value-happy {
    @apply flex flex-col;
}
.div-option-value-happy {
    @apply flex items-center min-w-full gap-2 border-b  border-border-gray-happy-light;
}

.div-option-value-description-happy {
    @apply flex items-center min-w-full justify-between px-3;
}

.div-info-option-value-happy {
    @apply flex items-center gap-2;
}

.img-option-value-happy {
    @apply w-11 h-11 object-contain;
}
.text-option-value-happy {
    @apply text-wrap w-full;
}
</style>
